import { z } from 'zod'
import source from './data-processing-policy-document.json'

const text = z.string().min(1)
const block = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('paragraph'), text }),
  z.object({ kind: z.literal('heading'), text }),
  z.object({ kind: z.literal('list'), items: z.array(text).min(1) }),
  z.object({ kind: z.literal('table'), headers: z.array(text).min(2), rows: z.array(z.array(text).min(2)).min(1) })
])
const policySchema = z.object({
  version: z.string().regex(/^[a-f0-9]{64}$/),
  sourcePageCount: z.number().int().positive(),
  qualityManagement: z.object({ system: text, process: text, title: text, code: text, revision: text, issuedOn: text }),
  introduction: z.array(block).min(1),
  sections: z.array(z.object({
    id: z.string().regex(/^[a-z0-9-]+$/),
    number: text.nullable(),
    title: text,
    blocks: z.array(block).min(1)
  })).min(1)
})

export const dataProcessingPolicy = policySchema.refine(document =>
  [...document.introduction, ...document.sections.flatMap(section => section.blocks)]
    .every(block => block.kind !== 'table' || block.rows.every(row => row.length === block.headers.length)),
'Table cells must match their headers.'
).parse(source)
